
// eslint-disable-next-line no-unused-vars
//import Symbol from '~/core-js/modules/es.symbol'
import '~/core-js/modules/es.array.from'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@/style/index.scss'
import { createApp } from '../createApp'
import { clientsideSetup } from '../global-clientside'
import '@/login/main'

// `epiMessages` does not export anything but registers the `beta/contentSaved`
// and `beta/epiReady` message handlers
import '../epiMessages'

clientsideSetup()

let ssrComponents = document.querySelectorAll('[data-server-rendered]')
window.vueinstances = []
ssrComponents.forEach(component => {
  //console.log(`COMPONENT:`, component)
  let componentId = component.getAttribute('data-componentid')
  //console.log(`COMPONENTID: ${componentId}`)
  const componentData = window._vueContext[componentId]
  //componentData.data.isLoggedIn = true
  //console.log(`COMPONENTDATA:`, componentData)

  if (componentData) {
    let isLoggedIn = (componentData.data && componentData.data.isLoggedIn)
    let editModeActive = (componentData.renderSettings && componentData.renderSettings.isInEditMode)

    const app = createApp(componentData.data, componentId, editModeActive, isLoggedIn)
    app.$mount(component)
    window.vueinstances[componentId] = app
  } else {
    console.warn('Could not load component: ', component)
  }
})
